import Axioscall from "./Axios";

//property data api
export const propertyTypeData = (propertyData) => {
  return Axioscall.post("preferredDevice", propertyData);
};

//device list api
export const deviceListApi = () => {
  return Axioscall.get("deviceList");
};

//recommended product
export const recommendedProductApi = (productDetails) => {
  return Axioscall.post("recommendedProduct", productDetails);
};

// recommended products api
export const FindDealerApi = (search) => {
  return Axioscall.get(`findDealer?search=${search}`);
};

// Connect Dealer api
export const ConnectDealerApi = (userDetails) => {
  return Axioscall.post(`connectDealer`, userDetails);
};
